import { createSlice } from "@reduxjs/toolkit";
import { exportClaims } from "../../reducer/claimsexport/claimsexportReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const exportClaimsSlice = createSlice({
  name: "exportClaims",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(exportClaims.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(exportClaims.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(exportClaims.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default exportClaimsSlice.reducer;
